import React, { useEffect, useState } from "react";
import { obtenerEstudio, guardarEstudio } from "../api";
import { toast } from "react-toastify";
import { HiSave, HiX, HiOutlineDocumentReport } from "react-icons/hi";
import "../styles.css";

const campos = [
  { key: "titulo_obra", label: "Título de la Obra", type: "text" },
  { key: "num_oferta", label: "Nº Oferta", type: "text" },
  { key: "tipologia_obra", label: "Tipología de Obra", type: "text" },
  { key: "porcentaje_tipologia", label: "% Tipología", type: "number" },
  { key: "comunidad_autonoma", label: "C. Autonoma / País", type: "text" },
  { key: "tecnico_estudio", label: "Técnico en Estudio", type: "text" },
  { key: "ute", label: "U.T.E", type: "text" },
  { key: "otras_empresas_ute", label: "Otras empresas U.T.E", type: "text" },
  { key: "tipo_entidad", label: "Tipo de Entidad", type: "text" },
  { key: "cliente", label: "Cliente / Organismo", type: "text" },
  { key: "clave_obra", label: "Clave de Obra", type: "text" },
  { key: "plazo_ejecucion", label: "Plazo de Ejecución", type: "text" },
  { key: "porcentaje_comunidad", label: "% Comd Autónoma", type: "number" },
  { key: "porcentaje_vipeca", label: "% Vipeca, S.L.", type: "number" },
  { key: "porcentaje_empresas_ute", label: "% Empresas U.T.E", type: "number" },
  { key: "tipo_entidad_publica", label: "Entidad Pública", type: "text" },
  { key: "fecha_presentacion", label: "Fecha presentación", type: "date" },
  { key: "fecha_apertura", label: "Fecha Apertura", type: "date" },
  { key: "presupuesto_sin_iva", label: "Presup. sin I.V.A.", type: "number" },
  { key: "iva", label: "I.V.A.", type: "number" },
  { key: "presupuesto_con_iva", label: "Presup. con I.V.A.", type: "number" },
  { key: "presupuesto_licitacion", label: "Presupueto Licitación", type: "number" },
  { key: "nif", label: "N.I.F.", type: "text" },
  { key: "consultas_administrativas", label: "Consultas admin", type: "text" },
  { key: "telefono_admin", label: "Teléfono (adm.)", type: "text" },
  { key: "consultas_tecnicas", label: "Consultas técnicas", type: "text" },
  { key: "telefono_tecnico", label: "Teléfono (téc.)", type: "text" },
  { key: "anualidades", label: "Anualidades", type: "text" },
  { key: "porcentaje_iva", label: "% I.V.A.", type: "number" },
  { key: "revision_precios", label: "Revisión precios", type: "text" },
  { key: "forma_pago", label: "Forma de pago", type: "text" },
  { key: "plazo_pago", label: "Plazo de Pago", type: "text" },
  { key: "director_obra", label: "Director de obra", type: "text" },
  { key: "fecha_anuncio", label: "Fecha anuncio", type: "date" },
  { key: "tipo_licitacion", label: "Tipo Licitación", type: "text" },
  { key: "subtipo_licitacion", label: "Subt. Licitación", type: "text" },
  { key: "hora_limite", label: "Hora Límite", type: "text" },
  { key: "lugar_presentacion", label: "Lugar present.", type: "text" },
  { key: "plazo_garantia", label: "Plazo garantía", type: "text" },
  { key: "fianzas", label: "Fianzas", type: "text" },
  { key: "retenciones", label: "Retenciones", type: "text" },
  { key: "sanciones", label: "Sanciones", type: "text" },
  { key: "hora_apertura", label: "Hora apertura", type: "text" },
  { key: "escritura_constitucion", label: "Escritura constitut.", type: "text" },
  { key: "dni_firmante", label: "DNI firmante", type: "text" },
  { key: "poderes_simple", label: "Poderes simple", type: "text" },
  { key: "poderes_bastanteados", label: "Poderes bastante.", type: "text" },
  { key: "clasificacion_contratista", label: "Clasificación Contrat.", type: "text" },
  { key: "vigencia_clasificacion", label: "Vigencia clasif.", type: "text" },
  { key: "clasificacion_empresarial", label: "Clasificación Empr.", type: "text" },
  { key: "cert_incompatibilidades_normal", label: "Cert. incomp. (N)", type: "text" },
  { key: "cert_incompatibilidades_especial", label: "Cert. incomp. (E)", type: "text" },
  { key: "cert_tributarias", label: "Cert. Trib.", type: "text" },
  { key: "iae", label: "I.A.E.", type: "text" },
  { key: "cert_seguridad_social", label: "Cert. S.S.", type: "text" },
  { key: "fianza_provisional", label: "Fianza Provisional", type: "text" },
  { key: "balance", label: "Balance", type: "text" },
  { key: "informes_financieros", label: "Informes financ.", type: "text" },
  { key: "aceptacion_contrato", label: "Aceptación Contrato", type: "text" },
  { key: "visado_colegio", label: "Visado Colegio", type: "text" },
  { key: "otros", label: "Otros", type: "text" },
  { key: "observaciones", label: "Observaciones", type: "textarea" },
  { key: "memoria_proceso_ejecucion", label: "Memoria ejecución", type: "text" },
  { key: "relacion_maquinaria", label: "Relación maquinaria", type: "text" },
  { key: "relacion_personal", label: "Relación personal", type: "text" },
  { key: "plan_trabajos", label: "Plan de trabajos", type: "text" },
  { key: "pert", label: "PERT", type: "text" },
  { key: "implantacion_zona", label: "Implantación zona", type: "text" },
  { key: "relacion_obras_ejecutadas", label: "Relación obras ejec.", type: "text" },
  { key: "certificados_obras_visadas", label: "Cert. obras visadas", type: "text" },
  { key: "certificado_volumen_obra", label: "Cert. volumen obra", type: "text" },
  { key: "control_calidad", label: "Control calidad", type: "text" },
  { key: "presupuesto_control_calidad", label: "Presup. calidad", type: "text" },
  { key: "plan_aseguramiento_calidad", label: "Plan aseg. calidad", type: "text" },
  { key: "presupuesto_seguridad", label: "Presup. seguridad", type: "text" },
  { key: "cuadro_precios_1", label: "Cuadro precios 1", type: "text" },
  { key: "cuadro_precios_2", label: "Cuadro precios 2", type: "text" },
  { key: "justificacion_precios", label: "Justif. precios", type: "text" },
  { key: "presupuesto", label: "Presupuesto", type: "text" },
  { key: "diskette", label: "Diskette", type: "text" },
  { key: "contacto_administracion", label: "Contacto admin", type: "text" },
  { key: "visita_zona", label: "Visita zona", type: "text" },
  { key: "peticion_ofertas", label: "Petición ofertas", type: "text" },
  { key: "procedencia_materiales", label: "Proced. materiales", type: "text" },
  { key: "comprobado_cuadro_precios", label: "Comp. cuadro prec.", type: "text" },
  { key: "repaso_calculos", label: "Repaso cálculos", type: "text" },
  { key: "comprobacion_mediciones", label: "Comp. mediciones", type: "text" },
  { key: "precios_unitarios", label: "Precios unitarios", type: "text" },
  { key: "precios_descompuestos", label: "Precios descomp.", type: "text" },
  { key: "cuadro_comparativo", label: "Cuadro comparativo", type: "text" },
  { key: "presupuesto_operado", label: "Presup. operado", type: "text" },
  { key: "relacion_industriales", label: "Relación industrial.", type: "text" },
  { key: "planos_documentos", label: "Planos y doc.", type: "text" },
  { key: "propuesta_modificacion", label: "Propuesta mod.", type: "text" },
  { key: "otros_documentos", label: "Otros documentos", type: "text" },
];

const categorias = [
  { titulo: "Obra", campos: campos.slice(0, 22) },
  { titulo: "Información", campos: campos.slice(22, 43) },
  { titulo: "Requisitos", campos: campos.slice(43, 80) },
  { titulo: "Actuaciones", campos: campos.slice(80, 87) },
  { titulo: "Documentos", campos: campos.slice(87) },
];

const InformeResumen = ({ numeroExpediente, onCerrar }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const cargar = async () => {
      try {
        const estudio = await obtenerEstudio(numeroExpediente, "informe_resumen");
        if (estudio) setData(estudio);
      } catch {
        console.warn("Sin datos previos");
      } finally {
        setLoading(false);
      }
    };
    cargar();
  }, [numeroExpediente]);

  const handleChange = (key, value) => setData({ ...data, [key]: value });

  const handleGuardar = async () => {
    try {
      await guardarEstudio(numeroExpediente, "informe_resumen", data);
      toast.success("Informe guardado");
    } catch {
      toast.error("Error al guardar informe");
    }
  };

  if (loading) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
      <div className="loader"></div>
    </div>
  );

  return (
    <div className="glass-panel animate-fadeIn" style={{ padding: '32px', borderRadius: 'var(--radius-lg)', maxWidth: '1100px', margin: '0 auto' }}>
      <div className="dashboard-header" style={{ marginBottom: '32px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div className="brand-logo" style={{ width: '48px', height: '48px', fontSize: '1.4rem' }}>
            <HiOutlineDocumentReport />
          </div>
          <div>
            <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 800 }}>Informe Resumen</h2>
            <p style={{ margin: 0, color: 'var(--text-secondary)', fontSize: '0.85rem' }}>Ficha técnica detallada de la oferta</p>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button className="btn-gestion" onClick={onCerrar} style={{ background: 'rgba(255,255,255,0.05)', color: 'var(--text-primary)' }}>
            <HiX /> Cerrar
          </button>
          <button className="btn-nueva" onClick={handleGuardar}>
            <HiSave /> Guardar Informe
          </button>
        </div>
      </div>

      <div className="tabs-container" style={{ display: 'flex', gap: '8px', marginBottom: '32px', overflowX: 'auto', paddingBottom: '8px', borderBottom: '1px solid var(--glass-border)' }}>
        {categorias.map((cat, idx) => (
          <button
            key={cat.titulo}
            onClick={() => setActiveTab(idx)}
            style={{
              padding: '10px 20px',
              borderRadius: 'var(--radius-md)',
              border: 'none',
              background: idx === activeTab ? 'rgba(56, 189, 248, 0.1)' : 'transparent',
              color: idx === activeTab ? 'var(--accent-primary)' : 'var(--text-secondary)',
              fontWeight: idx === activeTab ? 700 : 500,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              transition: 'var(--transition-fast)',
              borderBottom: idx === activeTab ? '2px solid var(--accent-primary)' : '2px solid transparent'
            }}
          >
            {cat.titulo}
          </button>
        ))}
      </div>

      <div className="tab-content animate-fadeIn" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
        {categorias[activeTab].campos.map((c) => (
          <div key={c.key} className="form-group" style={{ gridColumn: c.type === 'textarea' ? 'span 2' : 'span 1' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.8rem', color: 'var(--text-secondary)', fontWeight: 600, textTransform: 'uppercase' }}>{c.label}</label>
            {c.type === "textarea" ? (
              <textarea
                value={data[c.key] || ""}
                onChange={(e) => handleChange(c.key, e.target.value)}
                style={{ width: '100%', padding: '12px', minHeight: '100px', background: 'var(--bg-main)', border: '1px solid var(--glass-border)', borderRadius: 'var(--radius-md)', color: 'var(--text-primary)' }}
              />
            ) : (
              <input
                type={c.type}
                value={data[c.key] || ""}
                onChange={(e) => handleChange(c.key, e.target.value)}
                style={{ width: '100%', padding: '12px', background: 'var(--bg-main)', border: '1px solid var(--glass-border)', borderRadius: 'var(--radius-md)', color: 'var(--text-primary)' }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default InformeResumen;
